import { graphql } from '@teachino/shared-infrastructure';
import { featureFragment } from './feature.fragment';

export const personalLicenseFragment = graphql(
  `
    fragment PersonalLicense on License {
      id
      cycleStartAt
      cycleRenewalAt
      expiresAt
      plan {
        id
        features {
          ...Feature
        }
        key
        type
      }
    }
  `,
  [featureFragment],
);
